export enum Steps {
  WELCOME = 'welcome',
  TEMPLATE = 'template',
  WRITING = 'writing',
}

export enum VariantB {
  WELCOME = 'welcome',
  TEMPLATE = 'template',
}

export enum VariantC {
  WELCOME = 'welcome',
  TEMPLATE = 'template',
  WRITING = 'writing',
}

export type Variant = 'b' | 'c'

export type Item = {
  icon: 'tick' | 'template' | 'writing' | 'word' | 'customization'
  header: string
  description?: string
}

export type Header = {
  caption?: string
  header: string
  description?: string
}

export type Actions = {
  back: string
  continue: string
}
